import React, { Component } from 'react';
import { NumberInput } from '../components/NumberInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    prevStep(): void;
    nextStep(): void;
    updateLead(props:any): void;
    gtmEvent(): void;
    childcareCost?: number;
    maintenanceCost?: number;
    consent: boolean; 
}

interface IState {
    hasError: boolean;
    errors?: string[];
    childcareCost?: number;
    maintenanceCost?: number;
    consent?: boolean;
}

export class LVDependentCosts extends Component<IProps, IState> {
    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, childcareCost: this.props.childcareCost, maintenanceCost: this.props.maintenanceCost};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep() {
        const errors:string[]=[];
        if (!this.state.childcareCost) {
            errors.push("Childcare cost is required");         
        }

        // if (!this.state.maintenanceCost){
        //     errors.push('Maintenance cost is required');
        // }

        if (errors.length > 0) {
            this.setState({ hasError: true, errors });
            return;
        }
        this.setState({ hasError: false, errors: [] });
        this.props.nextStep();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'><span className='doddltext'>Dependent Details</span></h1>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <NumberInput
                                id='childcareCost'
                                key='childcareCost'
                                label={<> Childcare Cost</>}
                                value={this.props.childcareCost}
                                classes={this.state.hasError && !this.state.childcareCost ? "e" : ""}
                                onChange={(e) => { this.setState({childcareCost: e.target.value}); this.props.updateLead({lvchildcarecost:e.target.value}); }} />
                        </div>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='maintenanceCost'
                                key='maintenanceCost'
                                label={<>Any <strong>Maintenance</strong> costs</>}
                                value={this.props.maintenanceCost}
                                classes={this.state.hasError && !this.state.maintenanceCost ? "e" : ""}
                                onChange={(e) => { this.setState({maintenanceCost: e.target.value}); this.props.updateLead({lvmaintenancecost:e.target.value}); }} />
                        </div>
                    </div>

                    

                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton customLabel='Next' onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}